/**
 * Created by zhengyf on 2017/12/15.
 */

;(function () {

    rfqHeaderCtrl.$inject = ['request'];
    angular
        .module('DSSXAPP')
        .component('rfqHeader', {
            template:'<div class="rfq-header-box"><header class="sc-hd-header"><div class="sc-hd-row sc-hd-top"><div class="J-sc-hd-m-beaconnav"><ul class="util-clearfix"><li class="sc-hd-ms-dp-trigger" ng-repeat="nav in vm.c.leftNav track by $index"><span class="sc-hd-ms-title"><span ng-bind="nav.title"></span> <i class="iconfont icon-less"></i></span></li></ul></div><div class="sc-hd-absolute-r"><div class="rfq-tab"><div class="search-box sc-hd-ms-trigger"><i></i> <span>On Alibaba</span></div></div><div class="rfq-tab"><div class="sc-hd-ms-trigger"><div class="a"><div class="dh-avatar"><img ng-src="{{vm.usrInfo.usr.attrs.basic.avatar || \'/imgs/user.png\'}}"></div><div class="dh-menu"><div><div><img ng-src="{{vm.usrInfo.usr.attrs.basic.avatar || \'/imgs/user.png\'}}"></div><div><div>你好，{{vm.usrInfo.usr.attrs.basic.nickName}}</div><a href="/account-center.html" ng-hide="vm.isForbid">用户中心</a> <a ng-click="vm.logout()">退出</a></div></div><div>消息中心</div><div class="h-notify-item"><a href="javascript:;">待处理订单</a> <a href="javascript:;">0</a></div><div class="h-notify-item"><a href="inquiry-manage.html">未读询盘</a> <a href="inquiry-manage.html">3</a></div><div class="h-notify-item"><a href="javascript:;">未读人脉</a> <a href="javascript;;">0</a></div></div></div><div class="sc-hd-ms-title-top"><a href="index.html">My Alibaba</a> <span class="sc-hd-sc-num">0</span></div></div></div><div class="rfq-tab"><div class="sc-hd-ms-trigger"><a href="javascript:;"><img src="imgs/search_detail_order_icon.png"></a><div class="sc-hd-ms-title-top"><a href="javascript:;">Orders</a> <span class="sc-hd-sc-num">0</span></div></div></div><div class="rfq-tab"><div class="sc-hd-ms-trigger"><a href="javascript:;"><img src="imgs/search_detail_fav.png"></a><div class="sc-hd-ms-title-top"><a href="javascript:;">Favorites</a> <span class="sc-hd-sc-num">0</span></div></div></div></div></div><div class="sc-hd-row sc-hd-main"><div class="rfq-main-left"><a href="ali-index.html" class="rfq-logo"><img src="/images/common/kuxiao.png"></a><div class="rfq-cgzd"><a href="rfq-index.html">采购直达</a></div><div class="rfq-lang"><span>简体中文</span> <i class="iconfont icon-moreunfold"></i></div></div><div class="rfq-right"><ul class="rfq-right-list"><li class="rfq-right-item"><span>权益购买</span></li><li class="rfq-right-item"><span>Im A Buyer</span></li><li class="rfq-right-item"><span>商家中心</span></li><li class="rfq-right-item"><span>免费建站</span></li><li class="rfq-right-item"><span>交流区</span></li><li class="rfq-right-item"><span>帮助</span></li></ul></div></div></header></div>',
            bindings: {},
            controllerAs: 'vm',
            controller: rfqHeaderCtrl
        });

    function rfqHeaderCtrl(request) {

        var vm = this;

        vm.usrInfo = DSSX.currUser;

        vm.c = {
            leftNav: [
                {
                    title: 'Sourcing Solutions'
                },
                {
                    title: 'Services & Membership'
                },
                {
                    title: 'Help & Community'
                }
            ]
        }

        vm.logout = logout;

        function logout() {
            return request.get(DSSX.host.protocol + '//' + DSSX.host.sso + '/sso/api/logout', {token: DSSX.util.getToken()}, true)
                .then(function (rs) {
                    var code = DSSX.util.safe(rs, 'data.code', 0);
                    if (code !== 0) {
                        layer.msg('注销登录失败，错误代码：' + code);
                        return;
                    }
                    location.href = DSSX.host.protocol + '//' + DSSX.host.sso + '/sso/?url=' + encodeURIComponent(DSSX.host.protocol + '//' + DSSX.host.main);
                }, function (error) {
                    DSSX.dialog.err(error, {
                        moduleName: 'rfq退出登录',
                        funcName: 'logout',
                        text: '退出登录失败'
                    });
                });
        }


    }

})();
